export default {"src":"/_next/static/media/persons.b7dba92d.svg","height":24,"width":24};